import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ptg-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss']
})
export class ProgressSpinnerComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
